import { render, staticRenderFns } from "./SwitchListItem.vue?vue&type=template&id=25cf8340&"
import script from "./SwitchListItem.vue?vue&type=script&lang=ts&"
export * from "./SwitchListItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports